module.exports = __webpack_public_path__ + "img/log_dark_2.67763c32.png";